import { Schema, z } from 'zod';
import { BaseFieldDefinition, BaseFieldDefinitionSchema } from './base';
import { FieldDefinition, FieldDefinitionSchema } from './composite';

export namespace ObjectFieldDefinition {
  export const TYPE = 'object';
}

/**
 * Field definition of type object
 * @typedef ObjectFieldDefinition
 * @property - type : type of the field.
 * @property - fieldDefinitions : array of field definitions.
 */

export type ObjectFieldDefinition = BaseFieldDefinition & {
  type: typeof ObjectFieldDefinition.TYPE;
  fieldDefinitions: ReadonlyArray<FieldDefinition>;
};

export const ObjectFieldDefinitionSchema: Schema<ObjectFieldDefinition> =
  BaseFieldDefinitionSchema.and(
    z.object({
      type: z.literal(ObjectFieldDefinition.TYPE),
      fieldDefinitions: z.array(z.lazy(() => FieldDefinitionSchema))
    })
  );
